<template>
  <div style="transition: 0.4s;" class="w-1/4 flex-1 bg-white rounded-xl space-y-6 p-6 tip-block" :class="`step${ nowStep }`">
    <p v-html="content"></p>
    <div class="tip-footer">
      <button
        :style="{ opacity: nowStep === 19 ? 1 : 0 }"
        class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
        :disabled="nowStep === 1"
        @click="closeTips()"
      >
        {{closeTipsText}}
      </button>
      <button
        v-if="nowStep === 34 || (nowStep === 28 && efficientAi == true)"
        class="hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 text-blue-800 transition duration-500 ease-in-out border-yellow-400 border-2 bg-yellow-300"
        @click="next()"
      >
        {{finishText}}
      </button>
      <button
        v-else
        class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400"
        @click="next()"
      >
        {{nextText}}
      </button>

    </div>
  </div>
</template>

<script>
import * as contentData from '@/components/Tips/goalsAndBudgetTips.json';

export default {
  name: 'GoalsAndBudgetTips',
  props: {
    nowStep: {
      type: Number,
      default: 19
    },
    selectLang: {
      type: String
    },
    efficientAi: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      nextText: '下一步',
      finishText: '完成',
      closeTipsText: '跳過教學'
    }
  },
  computed: {
    content() {
      const data = contentData.default.filter(e => e.step === this.nowStep);
      let message;
      if (data.length > 0) {
        message = data[0].content_zh_TW;
        if(this.selectLang == 'zh-CN'){
          this.nextText = '下一步';
          this.finishText = '完成';
          this.closeTipsText = '跳过教学';

          message = data[0].content_zh_CN;
        }
        if(this.selectLang == 'en-US'){
          this.nextText = 'next';
          this.finishText = 'finish';
          this.closeTipsText = 'skip teaching';

          message = data[0].content_en_US;
        }
      } else {
        message = '';
      }
      return message;
    }
  },
  methods: {
    next() {
      this.$emit('nextStep');
      // this.nowStep = this.nowStep + 1;
    },
    closeTips() {
      this.$emit('closeTips');
    }
  }
};

</script>

<style lang="scss">

.tip-block {
  box-shadow: 4px 8px 16px 4px rgba(135, 135, 135, 0.6);
  z-index: 100;
}

.step19 {
  position: absolute;
  top: 50vh;
  left: 55vw;
}

.step20 {
  position: absolute;
  top: 40vh;
  left: 55vw;
}

.step21 {
  position: absolute;
  top: 38vh;
  left: 55vw;
}

.step22 {
  position: absolute;
  top: 38vh;
  left: 55vw;
}

.step23 {
  position: absolute;
  top: 38vh;
  left: 55vw;
}

.step24 {
  position: absolute;
  top: 38vh;
  left: 55vw;
}

.step25 {
  position: absolute;
  top: 38vh;
  left: 55vw;
}

.step26 {
  position: absolute;
  top: 38vh;
  left: 55vw;
}

.step27 {
  position: absolute;
  top: 38vh;
  left: 55vw;
}

.step271 {
  position: absolute;
  top: 38vh;
  left: 55vw;
}

.step272 {
  position: absolute;
  top: 38vh;
  left: 55vw;
}

.step28 {
  position: absolute;
  top: 55vh;
  left: 55vw;
}

.step29 {
  position: absolute;
  top: 48vh;
  left: 55vw;
}

.step30 {
  position: absolute;
  top: 48vh;
  left: 55vw;
}

.step31 {
  position: absolute;
  top: 43vh;
  left: 55vw;
}

.step32 {
  position: absolute;
  top: 43vh;
  left: 55vw;
}

.step33 {
  position: absolute;
  top: 43vh;
  left: 55vw;
}

.step34 {
  position: absolute;
  top: 45vh;
  left: 60vw;
}

.tip-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

</style>
